module.exports = __webpack_public_path__ + "static/media/cesura-5.142272a0.jpg";